import { css } from '@lyearn/style';

export const inputStyles = css`
  input {
    padding: 1px 0px;
    max-height: 28px;
    margin-top: 2px;
    width: 100%;
  }
`;
